import { get } from "../GenericServices";

const WorkProgressProject = {
  getProjectReport: (queryString) => {
    return get(`work-progress-project/find?${queryString}`);
  },
  downloadProjectReport: (queryString) => {
    return get(`work-progress-project/export?${queryString}`);
  },
};

export default WorkProgressProject;
